import { Moment } from 'moment';

/**
 * Konvertiert ein Date-Objekt oder ISO-String in das Format YYYY-MM-DD.
 * Ignoriert dabei die Zeitzone, um Datumverschiebungen zu vermeiden.
 * 
 * @param date - Date-Objekt oder ISO-String
 * @returns Formatiertes Datum als YYYY-MM-DD String oder undefined
 */
export function formatDateToYYYYMMDD(date: Date | string | null | undefined): string | undefined {
  if (!date) return undefined;
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}

/**
 * Konvertiert ein Moment-Objekt in das Format YYYY-MM-DD.
 * 
 * @param date - Moment-Objekt
 * @returns Formatiertes Datum als YYYY-MM-DD String oder undefined
 */
export function convertMomentToISODateString(date?: Moment | null): string | undefined {
  return date?.format('YYYY-MM-DD');
}
